import { HStack, IconButton, Tabs, UseDisclosureReturn } from "@chakra-ui/react"
import { AugmentationToolbarHookReturn } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import Pathicon from "../../pathicon/Pathicon"

type CertificateAugmentationHeaderProps = {
  toolbar: AugmentationToolbarHookReturn
  disclosure?: UseDisclosureReturn
}

const CertificateAugmentationHeader = ({
  toolbar,
  disclosure
}: CertificateAugmentationHeaderProps) => {
  return (
    <HStack w="100%" justifyContent="space-between">
      {/* TODO: consider a AugmenationTabsList? */}
      <Tabs.List
        paddingLeft={2}
        paddingRight={2}
        justifyContent="center"
        borderBottom="none"
        w="100%"
      >
        {toolbar.options.map((option) => (
          <Tabs.Trigger
            key={option.key}
            value={option.key}
            gap={1}
            fontWeight="bold"
            borderBottom="none"
            opacity=".45"
            _selected={{ color: "black", opacity: "1" }}
            onClick={() => toolbar.onSelect(option.key)}
            borderRadius="20px"
          >
            <Pathicon icon={option.icon} size="1em" /> {option.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>

      {!!disclosure && (
        <IconButton
          aria-label="Close"
          children={<Pathicon icon="x" />}
          h={8}
          minW={8}
          borderRadius="full"
          cursor="pointer"
          colorPalette="blackAlpha"
          variant="ghost"
          onClick={disclosure.onClose}
        />
      )}
    </HStack>
  )
}

export default CertificateAugmentationHeader
